import { Button, Grid, TextField, Typography } from "@mui/material";
import type { Theme } from "@mui/material/styles";
import { styled } from "@mui/system";

export const ResetPasswordContainer = styled("div")(({ theme }) => ({
  height: "100vh",
  boxShadow: "none",
  color: "white",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.down("md")]: {
    padding: "0px 20px",
  },
}));

export const LoginLink = styled(Typography)({
  textAlign: "center",
  fontSize: "14px",
  color: "#7B858B",
});

export const LogoBox = styled(Grid)(({ theme }) => ({
  textAlign: "center",
  marginBottom: "20px",
  maxWidth: "559px",
  justifyContent: "center",
  color: theme.palette.primary.main,
  fontSize: "82px",
  fontStyle: "normal",
  fontWeight: 600,
  letterSpacing: "-0.56px",
  "@media (max-width:899px)": {
    fontSize: "73px",
  },
  "@media (max-width:500px)": {
    fontSize: "68px",
  },
  "@media (max-width:450px)": {
    fontSize: "60px",
  },
  "@media (max-width:400px)": {
    fontSize: "48px",
  },
  "@media (max-width:342px)": {
    fontSize: "45px",
  },
  "@media (max-width:305px)": {
    fontSize: "40px",
  },
}));

export const Form = styled("form")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100vw",
  maxWidth: "540px",
  [theme.breakpoints.down("md")]: {
    padding: "20px",
  },
}));

export const FieldWrapper = styled(Grid)({
  marginBottom: "20px",
});

export const EmailField = styled(TextField)(({ theme }: { theme: Theme }) => ({
  border: "1px solid #fff", //border color
  borderRadius: 16,
  height: "70px",
  label: {
    color: "#8D9DA7", //text color
    fontSize: "16px",
    fontWeight: "500",
    marginTop: "7px",
  },
  "& .MuiInputBase-input": {
    color: "#002035", // text input
    fontSize: "16px",
    padding: "16px",
    "&:-webkit-autofill": {
      transitionDelay: "9999s",
      transitionProperty: "background-color, color",
    },
  },
  "& .MuiFilledInput-root": {
    border: "1px solid white", //border color
    borderRadius: 16,
    backgroundColor: "#F8F9F9",
    paddingTop: "8px",
    padingLeft: "8px",
  },
  "& .MuiFormLabel-root": {
    fontWeight: 400, // Text input size
  },
  "& .MuiFormLabel-root.MuiInputLabel-shrink": {
    backgroundColor: "#fff",
    color: "#002035",
    padding: "2px",
    marginTop: "-18px",
  },
  "& .MuiFilledInput-root.Mui-focused": {
    border: "1px solid #002035", //border color
    borderRadius: 16,
  },
  "& label.Mui-focused": {
    color: "#8D9DA7",
  },
  "& .MuiFormHelperText-root.Mui-error": {
    fontSize: "14px",
    margin: "5px 0px",
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.error.main,
  },
  "& .MuiFormHelperText-root": {
    fontSize: "14px",
    margin: "5px 0px",
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.error.main,
  },
  "& .MuiFormLabel-root.Mui-error": {
    fontSize: "16px",
    fontWeight: theme.typography.fontWeightMedium,
    color: "#8D9DA7",
  },
  "& .MuiFilledInput-root.Mui-error": {
    border: "1px solid #FC4C4C", //border color
    backgroundColor: "#FFF6F6",
    fontSize: "16px",
    fontWeight: theme.typography.fontWeightMedium,
    color: "#8D9DA7",
  },
  "& p.css-14ieswp-MuiFormHelperText-root": {
    paddingTop: "6px",
    margin: "10px 0px",
    fontSize: "14px",
    fontWeight: theme.typography.fontWeightMedium,
    color: "#8D9DA7",
  },
  "& .css-14ieswp-MuiFormHelperText-root.Mui-error": {
    color: theme.palette.error.main,
  },
  "& .MuiFilledInput-root:hover": {
    border: "1px solid #002035", //border color
    borderRadius: 16,
  },
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  marginTop: "15px",
  height: "48px",
  background: theme.palette.secondary.main,
  color: "#fff",
  borderRadius: "16px",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "22px",
  "&:hover": {
    borderRadius: "16px",
    background: "#FEDBDB",
    boxShadow: "none",
  },
}));
